<!--TemplateGroup:模板组展示 2024/08/22 13:56:24 YuAng-->

<template>
  <div class="group-template">
    <div class="template-item" v-for="(item,index) in list" :key="'template' + item.templateNum" :class="'template' + item.templateNum">
      <div class="template-content" title="预览模板">
        <el-image :src="item.picUrl" fit="scale-down" style="width: 100%; height: 100%" :preview-src-list="[item.picUrl]"></el-image>
        <span class="el-icon-search"></span>
      </div>
      <p class="template-radio">
        <el-radio v-model="form.templateNum" :label="item.templateNum">
          <span v-if="item.templateNum === 1">主模板</span>
          <span v-else-if="item.templateNum === 2">副模板</span>
          <span v-else>多模板{{index + 1}}</span>
        </el-radio>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TemplateGroup',
  props: {
    form: {
      type: Object,
      default: function () {
        return {
          templateNum: ''
        }
      }
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>

<style scoped>
.group-template {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.template-item {
  flex: 0 0 calc(33.3% - 11px);
  box-sizing: border-box;
  margin-right: 16px;
}

.template-item:nth-child(3n) {
  margin-right: 0;
}

.template-content {
  width: 100%;
  height: 170px;
  background: #f0f0f0;
  position: relative;
}

.template-content .el-icon-search {
  position: absolute;
  right: 0;
  bottom: 0;
  color: white;
  display: inline-block;
  width: 30px;
  height: 26px;
  background: rgba(51, 51, 51, 0.5);
  border-start-start-radius: 8px;
  border-start-end-radius: 8px;
  border-end-start-radius: 8px;
  cursor: pointer;
  text-align: center;
  line-height: 26px;
  pointer-events: none;
}

.template-content:hover .el-icon-search {
  background: #005eff;
}

.template-radio {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.template-radio ::v-deep .el-radio__label {
  color: #333 !important;
}
</style>